export default __webpack_public_path__ + "static/media/Batman.2e5d7ffe.png";